<div class="row">
	<div class="form-group form-inline">
		<div class="col-xs-2">
			<select id="js-extension-selector" class="selectpicker dropup" data-style="btn-white">
				<option value=-1{{#unless activeID}} selected="selected"{{/unless}}>--</option>
				{{#each plugins}}
				<option value={{@index}}{{#COMPARE ../activeID "==" @index}} selected="selected"{{/COMPARE}}>{{label}}</option>
				{{/each}}
			</select>
		</div>
		{{#if activePlugin}}
		<div class="col-xs-10">
			<div id="js-extension-refresh" class="btn btn-white m-r-20"><i class="fa fa-refresh"></i></div>
			{{#if activePlugin.input}}
			<span>{{activePlugin.input.label}}</span>
			<input type="number" class="form-control input-sm m-l-10" id="js-extension-input" name="extension-in" placeholder="{{activePlugin.input.label}}" value="{{activePlugin.input.default}}" min="{{activePlugin.input.min}}" max="{{activePlugin.input.max}}">&nbsp;{{activePlugin.input.unit}}
			{{/if}}
		</div>
		{{/if}}
	</div>
</div>
